export const handleKeyDown = (ev) => {
  const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
  if (!/[0-9]/.test(ev.key) && !allowedKeys.includes(ev.key)) {
    ev.preventDefault();
  }
};
